import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.dataProcessingGroupByProgress;

const DataProcessingGroupByProgressData = createSelector([selector], (state) => state);

export default {
  DataProcessingGroupByProgressData
};
